import React from 'react';
import { Provider, Store } from 'react-redux';

import { FormWrapperComponent as FormWrapper } from '../../components/FormWrapper/FormWrapperComponent';
import { NewVerificationComponent } from '../../components/NewVerificationComponent';

import { DatabaseId, ReduxState, ProgramIdAction } from '../../lib/types/types';
import { assertValidProgramId } from '../../lib/types/assertions';
import { getStore } from '../../lib/VerificationService/VerificationServiceStore';

interface VerificationFormProps {
    programId: DatabaseId;
    trackingId?: string;
}

const store: Store<ReduxState> = getStore();

export const VerificationForm = React.forwardRef(({ programId, trackingId }: VerificationFormProps, ref: any) => {
    assertValidProgramId(programId);
    store.dispatch<ProgramIdAction>({ programId, type: 'PROGRAM_ID' });

    if (ref) {
        ref.current = {
            forceUpdate: React.useCallback(() => store.dispatch({ type: 'FORCE_UPDATE' }), []),
        };
    }

    return (
        <Provider store={store}>
            <FormWrapper>
                <NewVerificationComponent programId={programId} trackingId={trackingId} />
            </FormWrapper>
        </Provider>
    );
});
